/**
 * Copyright (c) 2010-2023 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { inject } from '@angular/core';
import { LiveSearchCommand } from './live-search.command';

export function liveSearchFactory() {
    const command = new LiveSearchCommand();
    command.setDependencies({});
    return command;
}
